import React, { useState } from 'react'
import Mapped from './Mapped';
import UnMapped from './UnMapped'
export default function Main({ communityId }) {
    const [viewScreen, setviewScreen] = useState("Mapped");
    const handlePage = (type) => {
        setviewScreen(type)
    }
    return (
        <div className='container-fluid full-height'>
            <div className='row'>
                <ul className='detail-page-hr-sub-tabs' style={{ paddingTop: '10px', margin: '0' }}>
                    <li className={viewScreen === 'Mapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('Mapped')}>Mapped Products</li>
                    <li className={viewScreen === 'UnMapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('UnMapped')}>Unmapped Products</li>
                </ul>
            </div>

            
            {
                viewScreen === "Mapped"  ?
                <Mapped communityId={communityId}/>
            :''}
            {
                viewScreen === "UnMapped"  ?
                <UnMapped communityId={communityId}/>
            :''}

        </div>
    )
}
